import { Input, HostBinding, Directive, OnInit } from '@angular/core';

@Directive({
  selector: '[sukaContainer]'
})
export class Container implements OnInit {

  /**
   * Sets the container type. Set to `fluid` for a full width container.
   */
  @Input() sukaContainer: 'default' | 'fluid' = 'default';

  @HostBinding('class.container') default = true;
  @HostBinding('class.container--fluid') fluid = false;

  public ngOnInit() {
    if (this.sukaContainer === 'fluid') {
      this.fluid = true;
      this.default = false;
    }
  }
}
